export default __webpack_public_path__ + "static/bed_w.2c119ad932e1322c4156a9eaa78f7edb.svg";